<template>
<div>
  <span v-if="debug === 'true' || debug === true">{{version}}</span>
  <!--- AGRUPAMIENTO POR TX -->

   <div v-if="tipoAgrupamiento === 1" >
     <b-card class="text-left mt-2" style="border: 1px solid #94D993; border-radius: 16px;">
       <b-row class="m-0">
         <em class="dienteTratamiento"></em>
         <SelectTratamientos
             style="width: 80%;"
             :indexPadecimiento="padecimientoOriginalIndex"
             :indexOpcion="opcionAceptada"
             :catalogoTratamientos="listaTratamientosCatalogo"
             :catalogokits="listaKitsProp"
             :idSeleccionado="padecimientoOriginal.idTratamiento"
             :tratamiento="padecimientoOriginal"
             :i="padecimientoOriginalIndex"
             :kits="true"
         ></SelectTratamientos>
<!--         <v-select
             class="ml-1 leterSize"
             style="width: 20%"
             placeholder="Selecciona un tratamiento"
             label="nombre"
             :options="listaTratamientosCatalogo"
             :reduce="(variable) => variable.idTratamiento"
             id="idTratamiento"
             v-model="padecimientoOriginal.idTratamiento"
             @input="obtenerTratamientoCambiarDos()"
         ><span slot="no-options">No hay datos disponibles</span>
         </v-select>-->
         <em
             v-show="padecimientoOriginal.idTratamiento != null || padecimientoOriginal.idKit === null"
             class="plusEdicion_svg"
             style="margin-left: 5px; cursor: pointer; padding-right: 4px;"
             v-b-tooltip.hover.top.v-light
             title="Agregar tratamiento"
             @click="agregarTratamiento()"
         ></em>
         <em class="trash_svg ml-1"
             style=" width: 17px; padding-right: 2px; cursor: pointer"
             v-b-tooltip.hover.top.v-light
             title="Eliminar registro"
             @click="eliminarTratamientoTodo()"
             />
       </b-row>
       <b-row class="m-0 bold mt-2">
         <b-col class="leterSize p-0 columnas-col" style="border-right: #ECECEC 1px solid;">OD’s afectados <validacion/></b-col>
         <b-col cols="2" class="leterSize bordeTable text-left p-0 pl-1 d-flex align-items-center"
                v-if="padecimientoOriginal.idKit !== null"
         >Tratamiento</b-col>
         <b-col cols="2" class="leterSize bordeTable text-left p-0 pl-1 d-flex align-items-center">Padecimiento <validacion/></b-col>
         <b-col class="leterSize bordeTable p-0 text-center columnas-col">Cantidad Tratamiento</b-col>
         <b-col class="leterSize bordeTable p-0 text-center columnas-col">Precio unitario</b-col>
         <b-col class="leterSize bordeTable p-0 text-center columnas-col" >Acciones</b-col>
       </b-row>

       <div >
         <div style="height: 0px; margin-left: 22px" v-if="padecimientoOriginal.idKit !== null">
           <v-select
                     class="ml-1"
                     style="width: 14%"
                     placeholder="Selecciona un OD"
                     :options="listaDientesCatalogo"
                     id="idDienteKit"
                     v-model="padecimientoOriginal.idDiente"
                     :reduce="(variable) => variable.idDiente"
                     label="nombre"
                     @input="pasarDatosALista(padecimientoOriginal)"
                     :clearable="false"
           >
           </v-select>
           <b-form-invalid-feedback :state="padecimientoOriginal.idDiente != null">
             Seleccione una opción
           </b-form-invalid-feedback>
         </div>
         <div  class="mt-2" v-for="(tx, index) in  padecimientoOriginal.listaTratamientos " :key="'initx-'+index">
           <b-row class="m-0">
             <b-col class="leterSize p-0 columnas-col">
               <div v-if="padecimientoOriginal.idKit === null">
                 <v-select
                           class="ml-1"
                           style="width: 100%"
                           placeholder=" OD"
                           :options="listaDientesCatalogo"
                           id="idDiente"
                           v-model="tx.idDiente"
                           :reduce="(variable) => variable.idDiente"
                           label="nombre"
                           @input="obtenerTratamientoCambiarDos(tx)"
                           :clearable="false"
                 ><span slot="no-options">No hay datos disponibles</span>
                 </v-select>
                 <b-form-invalid-feedback :state="tx.idDiente != null">
                   Seleccione una opción
                 </b-form-invalid-feedback>
               </div>
             </b-col>
             <b-col class="leterSize text-left"
                    v-if="padecimientoOriginal.idKit !== null"
             >
               {{tx.nombreTratamiento}}
             </b-col>
             <b-col class="leterSize p-0 columnas-col">
               <div v-if="padecimientoOriginal.idKit === null">
                 <v-select
                           class="ml-1"
                           style="width: 100%"
                           placeholder="Selecciona un padecimiento"
                           label="nombre"
                           :options="listaPadecimientoCatalogo"
                           :reduce="(variable) => variable.idPadecimento"
                           v-model="tx.idPadecimiento "
                           id="idPadecimento"
                           @input="obtenerTratamientoCambiarDos(tx)"
                 >
                 </v-select>
                 <b-form-invalid-feedback :state="tx.idPadecimiento != null">
                   Seleccione una opción
                 </b-form-invalid-feedback>
               </div>
               <div v-else>
                 <v-select
                           class="ml-1"
                           style="width: 100%"
                           placeholder="Selecciona un padecimiento"
                           label="nombre"
                           :options="listaPadecimientoCatalogo"
                           :reduce="(variable) => variable.idPadecimento"
                           v-model="padecimientoOriginal.idPadecimiento "
                           id="idPadecimento"
                           @input="pasarDatosALista(padecimientoOriginal)"
                           :clearable="false"
                 >
                 </v-select>
                 <b-form-invalid-feedback :state="padecimientoOriginal.idPadecimiento != null">
                   Seleccione una opción
                 </b-form-invalid-feedback>
               </div>
             </b-col>
             <b-col class="leterSize p-0 columnas-col">
              <span class="leterSize"
                    v-if="padecimientoOriginal.idKit === null"
              >
                           <b-form-input
                               type="number"
                               min="1"
                               max="100"
                               v-model="tx.cantidad"
                               @paste.prevent
                               @keydown.prevent
                               class="leterSize"
                               @input="obtenerTratamientoCambiarDos(tx)"
                           ></b-form-input>
              </span>
               <span class="leterSize" v-else>
               {{tx.cantidad}}
             </span>
             </b-col>
             <b-col class="leterSize p-0 columnas-col">
               <span class="leterSize" v-if="padecimientoOriginal.idKit === null">{{ tx.precioUnitario | monedaEntero }} </span>
               <span class="leterSize" v-else>{{ tx.precio | monedaEntero }} </span>
             </b-col>
             <b-col class="leterSize p-0 columnas-col">
               <em class="trash_svg" v-if="padecimientoOriginal.idKit === null"
                   style=" width: 17px; padding-right: 2px; cursor: pointer"
                   v-b-tooltip.hover.top.v-light
                   title="Eliminar registro"
                   @click="eliminarTratamientoAgregar(index)"/>
             </b-col>
           </b-row>
         </div>
       </div>

       <hr/>

       <div class="text-center leterSize" style="color: #D3540D"><p>Podrás revisar el descuento plan y promo en la presentación</p></div>
     </b-card>
   </div>


  <!--- AGRUPAMIENTO POR OD -->
   <div v-else>
     <b-card class="text-left mt-2" style="border: 1px solid #94D993; border-radius: 16px;">
       <b-row class="m-0">
        <span class="bold" style="font-size: 11px; color: #79ACCE">
          <em class="dienteTratamiento"></em>
           ÓRGANO DENTAL
        </span>
         <v-select  class="ml-1 leterSize"
                    style="width: 20%"
                    :options="listaDientesCatalogo"
                    v-model="padecimientoOriginal.idDiente"
                    placeholder="Selecciona un OD"
                    label="nombre"
                    :reduce="(variable) => variable.idDiente"
                    :clearable="false"
         >
           <template v-slot:option="option">
             <div :key="option.idDiente">
               {{ option.nombre }}
             </div>
           </template>
         </v-select>
         <em class="trash_svg ml-3"
             style=" width: 17px; padding-right: 2px; cursor: pointer"
             v-b-tooltip.hover.top.v-light
             title="Eliminar registro"
             @click="eliminarTratamientoTodo()"/>
       </b-row>
       <b-row class="m-0 bold mt-2">
         <b-col class="leterSize p-0 columnas-col" style="border-right: #ECECEC 1px solid;">Tratamiento
           <em
               class="plusEdicion_svg"
               style="margin-left: 5px; cursor: pointer; padding-right: 4px;"
               v-b-tooltip.hover.top.v-light
               title="Agregar tratamiento"
               @click="agregarTratamiento()"
           ></em>
         </b-col>
         <b-col cols="2" class="leterSize bordeTable text-left p-0 pl-1 d-flex align-items-center">Padecimiento</b-col>
         <b-col class="leterSize bordeTable p-0 text-center columnas-col">Cantidad Tratamiento</b-col>
         <b-col class="leterSize bordeTable p-0 text-center columnas-col">Precio unitario</b-col>
         <b-col class="leterSize bordeTable p-0 text-center columnas-col" >Acciones</b-col>
       </b-row>

       <div class="mt-2" v-for="(tx, index) in padecimientoOriginal.listaTratamientos" :key="'initx-'+index">
         <b-row class="m-0">
           <b-col class="leterSize p-0 columnas-col">
<!--             <SelectTratamientos
                 style="width: 80%;"
                 :indexPadecimiento="padecimientoOriginalIndex"
                 :indexOpcion="opcionAceptada"
                 :catalogoTratamientos="listaTratamientosCatalogo"
                 :catalogokits="listaKitsProp"
                 :idSeleccionado="padecimientoOriginal.idTratamiento"
                 :tratamiento="padecimientoOriginal"
                 :i="padecimientoOriginalIndex"
                 :kits="true"
             ></SelectTratamientos>-->

             <v-select
                 class="ml-1"
                 style="width: 100%"
                 placeholder="Selecciona un tratamiento"
                 label="nombre"
                 :options="listaTratamientosCatalogo"
                 :reduce="(variable) => variable.idTratamiento"
                 id="idTratamiento"
                 v-model="tx.idTratamiento"
                 @input="obtenerTratamientoCambiar(tx.idTratamiento, index, padecimientoOriginal)"
                 :clearable="false"
             ><span slot="no-options">No hay datos disponibles</span>
             </v-select>
           </b-col>
           <b-col class="leterSize p-0 columnas-col">
             <v-select
                 v-if="index == 0"
                 class="ml-1"
                 style="width: 100%"
                 placeholder="Selecciona un padecimiento"
                 label="nombre"
                 :options="listaPadecimientoCatalogo"
                 :reduce="(variable) => variable.idPadecimento"
                 v-model="tx.idPadecimiento"
                 @input="obtenerPadecimientoCambiar(tx.idPadecimiento)"
                 id="idPadecimento"
             ><span slot="no-options">No hay datos disponibles</span>
             </v-select>
             <div v-else>{{tx.nombrePadecimiento}}</div>
           </b-col>
           <b-col class="leterSize p-0 columnas-col">
              <span class="leterSize">
                           <b-form-input
                               type="number"
                               min="1"
                               max="100"
                               v-model="tx.cantidad"
                               @paste.prevent
                               @keydown.prevent
                               class="leterSize"
                           ></b-form-input>
              </span>
           </b-col>
           <b-col class="leterSize p-0 columnas-col">
             <span class="leterSize">{{ tx.precio | monedaEntero }} </span>
           </b-col>
           <b-col class="leterSize p-0 columnas-col">
             <em class="trash_svg"
                 style=" width: 17px; padding-right: 2px; cursor: pointer"
                 v-b-tooltip.hover.top.v-light
                 title="Eliminar registro"
                 @click="eliminarTratamientoAgregar(index)"/>
           </b-col>
         </b-row>
       </div>
       <div class="text-center leterSize" style="color: #D3540D"><p>Podrás revisar el descuento plan y promo en la presentación</p></div>
     </b-card>
  </div>
</div>
</template>

<script>
import SelectTratamientos from "@/version5/diagnostico/SelectTratamientos";
export default {
  name: "EdicionPtiAgregarTratamiento",
  components: {SelectTratamientos},
  props: {
    tipoAgrupamiento:Number,
    listaDientesCatalogo: Array,
    listaTratamientosCatalogo:Array,
    listaPadecimientoCatalogo:Array,
    padecimientoOriginal:Object,
    padecimientoOriginalIndex:Number,
    listaKitsProp: Array,
    indexExtra: String,
    opcionAceptada: Number,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    listTratamientosAgregar:[],
    catalogokits: null,
  }),
  watch: {
    padecimientoOriginal() {
      this.$emit("padecimientoActualizado", this.padecimientoOriginal);
    },


  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    agregarTratamiento(){
      let nuevoTx = {
        "idTratamiento":null,
        "idPadecimiento":null,
        "nombrePadecimiento": null,
        "idDiente":null,
        "estatus": 4,
        "idPtiTratamientoAnterior": null,
        "cantidad": 1,
        "nombreTratamiento": null,
        "numeroDiente": null,
        "precioUnitario": null
      }
      this.padecimientoOriginal.listaTratamientos.push(nuevoTx)
    },
    obtenerTratamientoCambiar(tratamiento,index, padecimientoOriginal){
      if(tratamiento !== null) {

        let objetoEncontradoDiente = this.listaDientesCatalogo.find(objeto => objeto.idDiente === padecimientoOriginal.idDiente);

        let objetoEncontrado = this.listaTratamientosCatalogo.find(objeto => objeto.idTratamiento === tratamiento);

        this.padecimientoOriginal.listaTratamientos[index].precio = objetoEncontrado.precio;
        this.padecimientoOriginal.listaTratamientos[index].nombreTratamiento = objetoEncontrado.nombre;
        this.padecimientoOriginal.listaTratamientos[index].numeroDiente = objetoEncontradoDiente.nombre;
        this.padecimientoOriginal.listaTratamientos[index].idDiente = objetoEncontradoDiente.idDiente;
        this.obtenerPadecimientoCambiar(this.padecimientoOriginal.listaTratamientos[0].idPadecimiento);
      }else{
        this.padecimientoOriginal.listaTratamientos[index].precio = null;
        this.padecimientoOriginal.listaTratamientos[index].cantidad = 0;
        this.padecimientoOriginal.listaTratamientos[index].nombreTratamiento = null;
      }
    },
    obtenerPadecimientoCambiar(padecimiento){
      if(padecimiento !== null) {
        let objetoEncontrado = this.listaPadecimientoCatalogo.find(objeto => objeto.idPadecimento === padecimiento);
        this.padecimientoOriginal.listaTratamientos.forEach((pade,ind) => {
          if (ind !== 0){
            pade.idPadecimiento =  objetoEncontrado.idPadecimiento;
            pade.nombrePadecimiento = objetoEncontrado.nombre;
          }
        })
      }else{
        this.padecimientoOriginal.listaTratamientos.forEach((pade,ind) => {
          if (ind !== 0){
            pade.idPadecimiento =  null;
            pade.nombrePadecimiento = null;
          }
        })
      }
    },
    pasarDatosALista(padecimientoOriginal){
      if (this.padecimientoOriginal.idKit !== null){
        let objetoEncontradoDiente = this.listaDientesCatalogo.find(objeto => objeto.idDiente === padecimientoOriginal.idDiente);
        console.log("objetoEncontradoDiente >>>> ", objetoEncontradoDiente)
        this.padecimientoOriginal.numeroDiente = objetoEncontradoDiente.nombre;

        this.padecimientoOriginal.listaTratamientos.forEach(p => {
          p.idDiente = this.padecimientoOriginal.idDiente;
          p.idPadecimiento = this.padecimientoOriginal.idPadecimiento;
          p.estatus = 4
          p.idKit = this.padecimientoOriginal.idKit
        })

      }
    },
    obtenerTratamientoCambiarDos(tx){

      if(this.tipoAgrupamiento == 1){
        if(this.padecimientoOriginal.idTratamiento !== null) {

          if (tx != null){
          let  objetoDienteEncontrado = this.listaDientesCatalogo.find(objeto => objeto.idDiente === tx.idDiente );
            console.log(objetoDienteEncontrado, tx, "#")
            tx.numeroDiente = objetoDienteEncontrado.nombre
          }


          let objetoEncontrado = this.listaTratamientosCatalogo.find(objeto => objeto.idTratamiento === this.padecimientoOriginal.idTratamiento );
          this.padecimientoOriginal.listaTratamientos.forEach( item=>{
            item.precio = objetoEncontrado.precio;
            item.nombreTratamiento = objetoEncontrado.nombre
            item.idTratamiento = this.padecimientoOriginal.idTratamiento
          });



        }else{
          this.padecimientoOriginal.listaTratamientos.forEach( item=>{
            item.precioUnitario = 0;
            item.cantidad = 1;
            //item.nombreTratamiento = null
           // item.numeroDiente = null
            item.estatus = 4
            item.idKit = this.padecimientoOriginal.idKit
          });

          console.log("Aqui222", this.padecimientoOriginal)
        }
      }
    },
    eliminarTratamientoAgregar(index){
      this.padecimientoOriginal.listaTratamientos.splice(index, 1);
    },
    eliminarTratamientoTodo(){
      this.$emit('desactivarApartado', this.padecimientoOriginalIndex);
    }
  }
}
</script>

<style scoped>
.leterSize{
  font-size: 10px !important;
  color: #4F4F4F;
}
.bordeTable{
  border-bottom: #ECECEC 1px solid;
}
.columnas-col {
  display: flex;
  align-items: center;
  justify-content: center;
}
.cambiarTratamientoNuevoClass{
  border: 2px solid #D6E7F3 !important;
  padding: 20px !important;
  border-radius: 15px !important;
}
</style>
